import React from 'react';
import { Route } from 'react-router-dom';
import DashboardPageRoute from './DashboardPageRoute';

export default (
  <Route exact path="/v2/">
    <DashboardPageRoute />
  </Route>
);
